module.exports = ".advanced-search {\n    border-top: 1px solid #edf0f4;\n    margin: -1em 1.5em 0.4em 0;\n    padding-top: 1em;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/rastreamentos/rastreamento-historico/rastreamento-historico.component.css
 ** module id = 835
 ** module chunks = 0
 **/